/**
 * Three legal pages — Terms, Privacy, Refund — share this Layout so styling is consistent.
 * Each page renders a single Markdown-like body inside a left-aligned long-form container.
 */
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function LegalLayout({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--ink-1)" }} data-testid={testId}>
      <header className="sticky top-0 z-30 backdrop-blur-xl border-b border-[var(--ink-border)]" style={{ backgroundColor: "rgba(10,20,36,0.85)" }}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Logo size="md" variant="lockup" linkTo="/" dark />
          <nav className="flex items-center gap-5 text-sm text-white/70">
            <Link to="/why" className="hover:text-white">Why ArmIQ</Link>
            <Link to="/pricing" className="hover:text-white">Pricing</Link>
            <Link to="/login" className="hover:text-white">Sign in</Link>
          </nav>
        </div>
      </header>

      <section className="max-w-3xl mx-auto px-6 pt-14 pb-24">
        <div className="text-[10px] tracking-[0.3em] font-bold uppercase text-white/40">Legal</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-white mt-2 leading-[0.95]">{title}</h1>
        <div className="text-xs text-white/50 mt-3">Last Updated: <span className="font-mono-num">{lastUpdated}</span></div>

        <div className="prose prose-invert mt-10 text-white/80 leading-relaxed text-[15px]" style={{ maxWidth: "none" }}>
          {children}
        </div>

        <div className="mt-16 flex flex-wrap gap-3 text-xs text-white/40">
          <Link to="/terms" className="hover:text-white">Terms of Service</Link>
          <span>·</span>
          <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <span>·</span>
          <Link to="/refund-policy" className="hover:text-white">Refund Policy</Link>
        </div>
      </section>
    </div>
  );
}
